<template>
  <div class="ac-card-content">
    <div class="del-header-container">
      <div class="flex-row">
        <img src="@shared/assets/img/general/alert.png" class="ac-info" alt="Information">
        <div class="ac-header">
          Delete Plan
        </div>
      </div>
    </div>
    <div class="del-card-body-ft-container">
      <div class="ac-body-container">
        <div class="ac-body">
          <div class="del-info-container">
            <div class="del-info">
              {{ selectedPlan?.name }} Plan
            </div>
            <div class="del-info">
              Members Active: {{ selectedPlan?.activeMembers }}
            </div>
          </div>
          <div v-if="hasActiveMembers" class="del-body-text">
            This action is not permitted while members are currently enrolled in plan.
          </div>
          <div v-if="isSmacAdmin && !hasActiveMembers" class="del-body-text-2">
            Are you sure you want to delete this plan? This cannot be undone.
          </div>
          <div v-else-if="!isSmacAdmin" class="del-body-text-3">
            If you have any question, please contact your Partner Success Manager directly, or email
            <a :href="`mailto:${psmEmail}`">{{ psmEmail }}</a>
          </div>
        </div>
      </div>
      <div class="del-ft-container">
        <button
          type="button"
          :class="[hasActiveMembers && isSmacAdmin ? 'primary-button active' : 'secondary-button']"
          @click="close"
        >
          Cancel
        </button>
        <button
          v-if="!hasActiveMembers && isSmacAdmin"
          type="button"
          :class="[hasActiveMembers ? 'primary-button active' : 'primary-button']"
          @click="handleButtonClick"
        >
          Delete
        </button>
        <a
          v-else-if="!isSmacAdmin"
          class="primary-button active"
          :href="emailHref"
        >
          Email
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

export default {
  name: 'DeletePlan',
  mixins: [partnerSettingsMixin],
  props: {
    close: Function,
    submit: Function,
    partnerPSM: Object,
  },
  computed: {
    hasActiveMembers() {
      return this.selectedPlan?.activeMembers > 0;
    },
    psmEmail() {
      if (this.partnerPSM && this.partnerPSM.email) {
        return this.partnerPSM.email;
      }
      return 'partners@smartac.com';
    },
    emailHref() {
      const planName = encodeURIComponent(this.selectedPlan?.name);
      const partnerName = encodeURIComponent(this.$store.state.admin?.corporation?.corporationName || 'Unknown Partner');
      const subject = `Delete ${planName} Plan Request - ${partnerName}`;
      return `mailto:${this.psmEmail}?subject=${subject}`;
    },
  },
  methods: {
    handleButtonClick() {
      if (!this.isSmacAdmin) {
        window.location.href = this.emailHref;
        this.close();
      } else {
        this.submit();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.del-info {
  font-size: 18px;
  font-weight: 600;
}

.del-info-container {
  display: flex;
  width: 652px;
  justify-content: space-between;
}

.del-header-container {
  padding: 24px 24px 0px 24px;
  display: flex;
  align-items: center;
  justify-content: flex-start;

  .ac-header {
    font-size: 1.25rem;
    font-weight: 600;
    margin-left: 12px;
  }

  .ac-info {
    width: 25px;
    object-fit: contain;
    margin-right: 6px;
  }
}

.del-body-text-base {
  font-size: 16px;
  color: #7F8290;
  text-align: start;
}

.del-body-text {
  @extend .del-body-text-base;
  margin-top: 12px;
}

.del-body-text-2 {
  @extend .del-body-text;
}

.del-body-text-3 {
  @extend .del-body-text;
  margin-bottom: 30px;
  margin-top: 30px;
}

.del-card-body-ft-container {
  margin-top: -14px;
}

.email-highlight {
  color: $NBLUE110;
}

.del-ft-container {
  display: flex;
  align-items: end;
  gap: 16px;
  justify-content: end !important;
  margin: 0 24px;
  margin-bottom: 40px;

  .secondary-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $WHITE;
    border: solid 4px $NBLUE100;
    border-radius: 8px;
    color: $NBLUE100;
    padding: 12px 18px;
    font-weight: 600;

    &.blue {
      background-color: $NBLUE100;
      opacity: 0.3;
      color: $NBLUE100;
    }
  }

  .primary-button {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: solid 4px $NBLUE100;
    background-color: $NBLUE100;
    border-radius: 8px;
    color: $WHITE;
    padding: 12px 18px;
    font-weight: 600;

    &.active {
      background-color: $NBLUE100;
    }

    &.inactive {
      opacity: 0.3;
    }
  }
}
</style>
